export const INITIAL_REGION_INFO = {
  regionCode: '',
  cityCode: '',
  regionName: '',
  cityName: '',
  searchClicked: false,
  multipleSelect: false,
};

export const INITIAL_FILTER_UI_STATE = {
  minPrice: '',
  maxPrice: '',
  minHousehold: '',
  maxHousehold: '',
  minArea: '',
  maxArea: '',
  minGap: '',
  maxGap: '',
  minYears: '',
  maxYears: '',
  selectedSubdistricts: [],
  selectedSubwayLines: [],
  maxWalkingTime: null,
  maxGangnamTime: null,
  hasSchool: true,
  isPriceFilterActive: false,
  isHouseholdFilterActive: false,
  isAreaFilterActive: false,
  isGapFilterActive: false,
  isMoveInDateFilterActive: false,
  isSubdistrictFilterActive: false,
  isSubwayFilterActive: false,
  isWalkingTimeFilterActive: false,
  isGangnamTimeFilterActive: false,
  isSchoolFilterActive: false,
};

export const INITIAL_FILTER_COMPONENT_STATE = {
  selectedRegion: '',
  selectedCities: [],
  subdistrictOptions: [],
  subwayLines: [],
};

export const INITIAL_RANGE_FILTER = { min: null, max: null };

export const INITIAL_SORT_CONFIG = {
  key: 'current_vs_peak_price',
  direction: 'ascending',
};
